import type { SVGProps } from 'react';

const paths = {
  download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  monitor: 'M3 4h18v13H3ZM8 21h8M12 17v4',
  help: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 8a3 3 0 0 1 6 1c0 2-3 2-3 5M12 17v.01',
  chevronDown: 'm6 9 6 6 6-6',
  logout: 'M9 4H4v16h5M9 12h12m-5-5 5 5-5 5',
  external: 'M14 3h7v7M10 14 21 3M10 3H3v18h18v-7',
  home: 'M3 10 12 3l9 7v10H6V10m4 10v-7h4v7',
  search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
  book: 'M5 3h14v18H5a3 3 0 0 1 0-6h14M5 3a2 2 0 0 0-2 2v13M8 7h7M8 10h5',
  star: 'm12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
  plus: 'M12 5v14M5 12h14',
  settings: 'M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1Z',
  folder: 'M3 5h6l2 3h10v12H3Z',
  file: 'M5 3h9l5 5v13H5ZM14 3v6h5M8 13h8M8 17h6',
  history: 'M3 11a9 9 0 1 1 2 7M3 4v7h7M12 7v6l4 2',
  fork: 'M6 3v12a3 3 0 0 0 3 3h3M18 3v6a3 3 0 0 1-3 3H9M12 12v9',
  sun: 'M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10M12 1v3M12 20v3M1 12h3M20 12h3M4 4l2 2M18 18l2 2M4 20l2-2M18 6l2-2',
  menu: 'M3 6h18M3 12h18M3 18h18',
  close: 'm6 6 12 12M6 18 18 6',
  arrow: 'M5 12h14m-5-5 5 5-5 5',
  shield: 'm12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Zm-4 9 3 3 5-6',
  lock: 'M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5Zm7 4v3',
  globe: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M3 12h18M12 3c-5 5-5 13 0 18 5-5 5-13 0-18',
  terminal: 'm5 7 5 5-5 5M13 17h6',
  copy: 'M9 9h11v12H9ZM15 5V3H3v12h2',
  check: 'm5 12 4 4 10-10',
  alert: 'M12 3 2 21h20ZM12 9v5M12 17v1',
  refresh: 'M20 7a9 9 0 0 0-15-1M4 17a9 9 0 0 0 15 1M20 3v5h-5M4 21v-5h5',
  chevronLeft: 'm14 6-6 6 6 6',
  chevronRight: 'm10 6 6 6-6 6',
  user: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-3a8 8 0 0 1 16 0v3',
  key: 'M14 5a5 5 0 1 1-2 8L4 21H1v-4l8-8a5 5 0 0 1 5-4M16 8h.01',
  issue: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M12 7.5v5M12 16v.01',
  proposal:
    'M6 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6 9v6M6 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M18 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M18 15V9a3 3 0 0 0-3-3h-3M14 3l-2 3 2 3',
  merged:
    'M6 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6 9v6M6 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M18 15.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6 9a9 9 0 0 0 9 6.5',
  chat: 'M4 5h16v11H10l-5 4v-4H4Z',
  comment: 'M4 5h16v11H10l-5 4v-4H4ZM8 9h8M8 12h5',
  tag: 'M3 12V4h8l10 10-8 8ZM8 8h.01',
} as const;

export function Icon({ name, ...props }: SVGProps<SVGSVGElement> & { name: keyof typeof paths }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d={paths[name]} />
    </svg>
  );
}
